export default __webpack_public_path__ + "static/media/change_pass_check_error.8b9ba89d.svg";